import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Modal } from "antd";

import IconButton from "../iconButton";

const { confirm } = Modal;

const TableRowActions = ({
  children,
  onEdit,
  onDelete,
  disabled,
  disabledDelete,
}) => {
  const intl = useIntl();
  const handleDeleteClick = useCallback(() => {
    confirm({
      title: intl.formatMessage({
        id: "messages.confirm",
        defaultMessage: "Potvrzení",
      }),
      content: intl.formatMessage({
        id: "messages.drop.question",
        defaultMessage: "Opravdu si přejete odstranit tento záznam?",
      }),
      okText: intl.formatMessage({
        id: "messages.yes",
        defaultMessage: "Ano",
      }),
      cancelText: intl.formatMessage({
        id: "messages.no",
        defaultMessage: "Ne",
      }),
      onOk: onDelete,
    });
  }, [intl, onDelete]);

  return (
    <div className="table-row-actions">
      {children}
      {onEdit && (
        <IconButton
          icon="edit"
          onClick={onEdit}
          disabled={disabled}
          title={intl.formatMessage({
            id: "messages.editItem",
            defaultMessage: "editovat záznam",
          })}
          className="table-row-action-button"
        />
      )}
      {onDelete && (
        <IconButton
          icon="delete"
          onClick={handleDeleteClick}
          title={intl.formatMessage({
            id: "messages.dropItem",
            defaultMessage: "smazat záznam",
          })}
          disabled={disabled || disabledDelete}
        />
      )}
    </div>
  );
};

export default TableRowActions;
